<template>
  <div class="page">
    <v-touch @swipeleft="doNext" @swiperight="doPrev" :swipe-options="{threshold:50,direction: 'horizontal'}" class="v-touch">
      <div class="timer">
        <div class="num">{{ active + 1 }}/{{ questions.length }}</div>
        <van-progress :percentage="(activeNum==0?1:activeNum)*100/questions.length" :show-pivot="false" stroke-width="6" class="progress"></van-progress>
        <div class="time"><span class="clock">{{ duration }}</span>
          <icon name="underway-o" color="#999" />
        </div>
      </div>

      <template v-for="(que,idx) in questions">
        <div :class="['que-panel',{'active':active === idx}]" v-if="active===idx" :key="que.id">
          <div class="question">
            <!-- 题干 -->
            <div class="title">
              <span>{{ idx + 1 }}、</span>
              <div v-html="que.title" style="display: inline"></div>
            </div>

            <!-- 选择题 -->
            <div class="options" v-if="que.type<3">
              <div :class="['item',{'right': isActive(que,option) }]" v-for="(option,i) in que.options" :key="i" @click="doSelect(que,option,i)">
                <span class="letter">{{ String.fromCharCode(65 + i) }}</span>
                <span class="name" v-html="option.name"></span>
              </div>
            </div>

            <!-- 双选题 -->
            <div class="double-check" v-if="que.type ==4">
              <div class="check_box_header"><span>喜欢</span> <span>不喜欢</span></div>
              <div :class="['check_box',{'like': option.like,'dislike':option.dislike}]" v-for="(option,i) in que.options" :key="i">
                <div :class="['check_left',{'disabled': countNum(que,option,0) }]" @click="selectLike(que,option,i,0)"></div>
                <p class="name" v-html="option.name"></p>
                <div :class="['check_right',{'disabled': countNum(que,option,1) }]" @click="selectLike(que,option,i,1)"></div>
              </div>
            </div>

            <!-- 团队角色，选项选分数 -->
            <div class="options" v-if="que.type == 5">
              <div v-for="(option,i) in que.options" :key="'opt-ten'+i">
                <div class="item">
                  <span class="letter">{{ String.fromCharCode(65 + i) }}</span>
                  <span class="name" v-html="option.name"></span>
                </div>
                <div class="opt-score-wrap">
                  <span v-for="k in 10" :key=k :class="['opt-score-li',{'active':option.score ===k,'disabled':option.score !==k && (que.total-(option.score||0)+k)>10}]" @click="doSelectScore(que,option,k)">{{k}}</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </template>
    </v-touch>
    <div class="footer">
      <div class="tools">
        <div class="menu" @click="doPrev">
          <icon name="arrow-left" size="20px" color="#00aaea" />
          <div class="name">上一题</div>
        </div>
        <div class="menu" @click="toSheet">
          <icon name="label-o" size="20px" color="#00aaea" />
          <div class="name">答题卡</div>
        </div>
        <div class="menu" @click="doFinish">
          <icon name="back-top" size="20px" color="#00aaea" />
          <div class="name">继  续</div>
        </div>
        <div class="menu" @click="doNext(true)">
          <icon name="arrow" size="20px" color="#00aaea" />
          <div class="name">下一题</div>
        </div>
      </div>
    </div>

    <popup v-model="answerSheet" position="bottom" :style="{ height: '50%' }" class="answer-sheet">
      <div class="header">答题卡</div>
      <div class="status-bar">
        <div class="actv">当前</div>
        <div class="undo">未做</div>
        <div class="right">已做</div>
      </div>
      <div class="que-idx-list">
        <div :class="['item',{'active':active === idx,'right':que.selected}]" v-for="(que,idx) in questions" :key="idx" @click="jump(idx)">{{ idx + 1 }}</div>
      </div>
    </popup>
  </div>
</template>
<script>
import { getUndoPaperInfo, doNext, doFinish } from "@api/eval";
import { Tag, Icon, Popup, Progress as VanProgress, Field, Toast } from "vant";
import { formatSeconds, isType } from "@utils/index";

export default {
  components: {
    Tag, Icon, Popup, VanProgress, Toast, Field
  },
  data: function() {
    return {
      projectId: this.$route.params.projectId,
      paper: {},
      startTime: new Date().getTime() / 1000,
      lastTime: new Date().getTime() / 1000,
      duration: "",
      answerSheet: false,
      questions: [],
      records: [],
      active: 0,
      id: this.$route.params.id,
      activeNum: 1
    };
  },
  created() {
    this.init();
  },
  methods: {
    toSheet() {
      this.answerSheet = true;
    },
    init() {
      Toast.loading({ duration: 0, forbidClick: true, message: "加载中..." });
      this.fetchQuestions();
    },
    fetchQuestions() {
      getUndoPaperInfo(this.projectId).then(res => {
        if (!res.result.paper) {
          this.$router.replace({ path: `/eval/result/${this.projectId}` });
        } else {
          this.questions = res.result.questions || [];
          this.paper = res.result.paper || {};

          const records = res.result.records;
          this.active = 0;

          document.title = this.paper.title;
          this.initRecord(records);
          //this.$forceUpdate();        //强制更新
        }
        Toast.clear();
      });
    },
    initRecord(records) {
      let that = this;
      if (records && Object.keys(records).length > 0) {
        this.questions.forEach(que => {
          let ans = records[que.id];
          if (ans) {
            let seleted = ans.length == 1 ? ans[0] : ans.join(",");
            this.$set(que, "selected", seleted);
          }
        });
        let alQueIds = Object.keys(records);
        let lastQueId = alQueIds[alQueIds.length - 1];
        this.active = this.questions.findIndex(que => que.id == lastQueId) || 0;
      }

      //开始计时
      setInterval(function() {
        that.duration = formatSeconds(new Date().getTime() / 1000 - that.startTime);
      }, 1000);
    },
    doSelect(que, opt) {                            //选择题
      let that = this;
      this.$set(que, "selected", opt.id);
      this.doRecord(que);

      if (que.type == 1) {      //单选题，300毫秒后自动进入下一题
        setTimeout(function() {
          that.doNext();
        }, 300);
      }
    },
    doSelectScore(que, opt,k) {                            //10分题目
      if(!que.scores){
        que.scores = {}
      }

      if((que.total-(opt.score||0)+k)>10){
        return;
      }

      console.info(opt,'xxx',que)
      this.$set(que, "selected", opt.id);
      this.$set(opt, "score",k);
      que.scores[opt.id] = k

      const total = Object.values(que.scores).reduce((pre,cur)=> {return pre+cur},0)
      this.$set(que, "total",total);
      this.doRecord(que);
    },
    selectLike(que, opt, i, type) {                   //双选题
      if (!que.selected) {
        que.selected = [[], []];
      }
      let likeList = que.selected[type] || [];
      let idx = likeList.indexOf(opt.id);

      if (idx == -1) {
        if (likeList.length < que.max) {
          likeList.push(opt.id);
          this.$set(opt, type == 0 ? "like" : "dislike", true);
        }
      } else {
        likeList.splice(idx, 1);
        this.$set(opt, type == 0 ? "like" : "dislike", false);
      }
      this.$set(que.selected, type, likeList);
      this.doRecord(que);
    },
    countNum(que, opt, type) {
      if (type == 0) {
        return que.options.filter(o => o.like).length == que.max;
      } else {
        return que.options.filter(o => o.dislike).length == que.max;
      }
    },
    isActive(que, opt) {
      if (que.type != 1 && que.multiple && que.multiple.includes(opt.id)) {         //多选题没做完，默认是正确的
        return true;
      } else {
        return que.selected == opt.id;
      }
    },
    tenDisabed(que, opt, k) {
      console.info(opt,'222',que,k)
      return false;
    },
    jump(idx) {
      this.active = idx;
      this.answerSheet = false;
    },
    doNext(flag = false) {
      let curTime = new Date().getTime() / 1000
      if(curTime - this.lastTime<2 && this.questions.length != this.active + 1){
        Toast("这不是赶路，不需要这么快！！");
      }


      if (flag && this.questions.length == this.active + 1) {
        Toast("提示：已经是最后一题啦！");
        return false;
      }
      if ((this.active + 1) < (this.questions.length)) {
        this.active++;
      }
      this.lastTime = new Date().getTime() / 1000
    },
    doPrev() {
      if (this.active > 0) {
        this.active--;
      }
    },
    doInput(que) {
      if (que.type == 4 && que.selected) {
        this.$set(que, "right", false);
        this.doRecord(que);
      }
    },
    doRecord(que) {
      this.activeNum = this.questions.filter(q => q.selected).length;

      let data = {
        projectId: this.projectId,
        paperId: this.paper.id,
        questionId: que.id,
        duration: parseInt(new Date().getTime() / 1000 - this.startTime)
      };

      if(que.type == 5){  //团队角色
        data.optionIds =  [que.scores]
      }else{
        data.optionIds = que.type == 1 ? [que.selected] : (isType(que.selected) == "String" ? que.selected.split(",") : que.selected)
      }

      //保存答题记录
      doNext(data);
    },
    doFinish() {
      let flag = true;
      this.questions.forEach(que => {     //双选校验
        if (que.type == 4 && (que.options.filter(o => o.like).length < que.min || que.options.filter(o => o.dislike).length < que.min)) {
          flag = false;
          return Toast(`至少选${que.min}项!`);
        }
      });

      if (flag) {
        let aws = this.questions.filter(x => x.selected).map(({ id, selected }) => {
          return { id, selected };
        });
        if (aws.length < this.questions.length) {
          Toast(`您还有${this.questions.length - aws.length}道题没做,不能交卷,请点击答题卡查看!`);
        } else {
          this.doSubmit();
        }
      }
    },
    doSubmit() {
      const data = { projectId: this.projectId, paperId: this.paper.id,duration: new Date().getTime() / 1000 - this.startTime};
      doFinish(data).then(res => {
        if (res.result) {     //答题完成跳转到答题报告页
          this.$router.replace({ path: `/eval/result/${this.projectId}` });
        } else {
          this.$router.replace({ path: `/eval/process/${this.projectId}` });
          // this.init();       //继续答下一道题
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #F5F5F5;

  .timer {
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #fff;
    height: 26px;
    margin-bottom: 8px;
    color: #999;

    .num {
      width: 50px;
      text-align: center;
    }

    .progress {
      flex: 1;
      margin: 0 8px;
    }

    .time {
      width: 90px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .clock {
        margin-right: 5px;
      }
    }
  }

  .que-panel {
    height: calc(100vh - 50px);
    overflow-y: auto;
    display: none;

    &.active {
      display: block;
    }
  }

  .question {
    padding: 20px 15px;
    background-color: #ffffff;
    margin-bottom: 20px;
    font-size: 14px;
    min-height: 300px;

    ::v-deep .van-tag {
      font-size: 12px;
      margin-right: 5px;
      font-weight: 400;
    }

    .title {
      margin-bottom: 15px;
      line-height: 24px;
      font-size: 16px;
      font-weight: 700;

      ::v-deep p:first-child {
        display: inline;
      }

      ::v-deep img {
        max-width: 100%;
      }
    }

    .options {
      .item {
        font-size: 16px;
        padding: 10px 8px;
        background-color: #f7f7f7;
        border: 1px solid #f7f7f7;
        border-radius: 4px;
        margin: 12px 0;
        display: flex;
        align-items: center;

        &.right {
          border: 1px solid #799a74;
          background-color: #e9fde1;
        }

        &.error {
          border: 1px solid #ca4848;
          background-color: #ffd9db;
        }

        .letter {
          margin: 0 10px;
        }

        .name {
          margin-left: 5px;
        }
      }
      .opt-score-wrap{
        display: flex;
        justify-content: center;
        align-items: center;

        .opt-score-li{
          border: 1px solid #1db0fc;
          border-radius: 50px;
          display: inline-block;
          width: 28px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          margin: 0 5px;
          &.active{
            border: 1px solid #799a74;
            background-color: #e9fde1;
          }
          &.disabled{
            background-color: #f7f7f7;
            border: 1px solid #f7f7f7;
          }
        }
      }
    }

    .input-area {
      background-color: #f7f7f7;
      border: 1px solid #e6e6e6;
      border-radius: 2px;
    }
  }

  .answer {
    padding: 10px 15px;
    background-color: #fff;
    min-height: 160px;

    .sign {
      margin: 8px 0;
      font-size: 14px;

      .title {
        margin-right: 10px;
      }

      .letter {
        &.success {
          color: #1abb1d;
        }

        &.error {
          color: #e93323;
        }
      }
    }

    .analysis {
      border-top: 1px solid #f3f3f3;
      margin-top: 15px;
      padding: 10px 0;
      color: #696969;
      font-size: 14px;

      .title {
        margin: 10px 0 5px;
        font-weight: 700;
        font-size: 12px;

        &:before {
          content: ' ';
          border-left: 3px solid #00aaea;
          height: 10px;
          display: inline-block;
          margin-right: 5px;
        }
      }

      .desc {
        line-height: 22px;
        color: #3c3c3c;
        margin-bottom: 20px;
      }
    }

  }

  .double-check {
    .check_box_header {
      width: 100%;
      border: 1px solid #E0E0E0;
      margin-top: 15px;
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #999;
      background: #f6f6f6;
      padding: 0 16px;
      height: 48px;
    }

    .check_box {
      width: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #E0E0E0;
      border-top: none;

      &:not(.like) {
        .check_left.disabled {
          background-position: center -24px !important;
        }
      }

      &:not(.dislike) {
        .check_right.disabled {
          background-position: center -48px !important;
        }
      }
    }

    .check_left, .check_right {
      width: 52px;
      display: flex;
      align-items: center;
      overflow: hidden;
      min-height: 24px;
      justify-content: center;
    }

    .check_box p {
      font-size: 14px;
      color: #333;
      margin: 12px 0;
      flex: 1;
    }

    .check_left {
      background: url("~@images/like.png") no-repeat;
      background-size: 24px;
      background-position: center -72px;
    }

    .like .check_left {
      background-position: center -96px;
    }

    .check_right {
      background: url("~@images/like.png") no-repeat;
      background-size: 24px;
      background-position: center -120px;
    }

    .dislike .check_right {
      background-position: center 0;
    }

    .check_box.like .name {
      color: #09BB07;
    }

    .check_box.dislike .name {
      color: #ca4848;
    }

    .check_box.like.dislike .name {
      color: #1989fa;
    }
  }

  .manipulate {
    margin: 30px 0;
    padding: 0 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .prev {
      padding: 0 25px 0 20px;
    }

    .next {
      padding: 0 20px 0 25px;
    }
  }

  .footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: content-box;
    height: 55px;
    background-color: #fff;
    box-sizing: border-box;
    border-top: 1px solid #ececec;

    .tools {
      display: flex;
      align-items: center;
      vertical-align: middle;
      justify-content: center;
      width: 100%;
      font-size: 14px;

      .menu {
        flex: 1;
        text-align: center;
        align-items: center;
        margin: 8px 0;
      }

      &.que-num {
        margin-right: 0;
      }

    }
  }

  .answer-sheet {
    font-size: 12px;

    .header {
      font-size: 14px;
      font-weight: 700;
      padding: 10px 0;
      text-align: center;
    }

    .status-bar {
      height: 42px;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .actv {
        margin-right: 15px;

        &:before {
          content: ' ';
          background-color: #00aaea;
          color: #fff;
          border: 1px solid #00aaea;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }

      .undo {
        margin-right: 15px;

        &:before {
          content: ' ';
          border: 1px solid #ccc;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }

      .right {
        margin-right: 15px;

        &:before {
          content: ' ';
          border: 1px solid #799a74;
          background-color: #e9fde1;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }

      .error {
        margin-right: 10px;

        &:before {
          content: ' ';
          border: 1px solid #ca4848;
          background-color: #ffd9db;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }

    }

    .que-idx-list {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 5px;

      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 8px 10px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border: 1px solid #ccc;

        &.right {
          border: 1px solid #1abb1d;
          background-color: #e9fde1;
          color: #1abb1d;
        }

        &.error {
          border: 1px solid #ca4848;
          background-color: #ffd9db;
          color: #ca4848;
        }

        &.active {
          border: 1px solid #00aaea;
          background-color: #00aaea;
          color: #FFFFFF;
        }
      }

    }
  }

}
</style>
